import { ref } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'

// Shared state for approval statuses so we don't fetch multiple times across components
const approvalStatuses = ref<any[]>([])
const isFetching = ref(false)

export function useApprovalStatus() {
  const fetchApprovalStatuses = async () => {
    if (approvalStatuses.value.length > 0 || isFetching.value) return

    isFetching.value = true
    try {
      const response = await apiUseCase.get('/transaction/v2/FuelingTransactions/ApprovalStatuses')
      if (!response.error) {
        approvalStatuses.value = response.result || []
      }
    } catch (err) {
      console.error('Error fetching approval statuses', err)
    } finally {
      isFetching.value = false
    }
  }

  const getDynamicStatusColor = (statusName?: string) => {
    if (!statusName) return '#6b7280'
    const status = approvalStatuses.value.find((s: any) => s.Name === statusName)
    return status?.PrimaryColor || '#6b7280'
  }

  const getDynamicStatusBg = (statusName?: string) => {
    if (!statusName) return 'rgba(107, 114, 128, 0.1)'
    const status = approvalStatuses.value.find((s: any) => s.Name === statusName)
    return status?.SecondaryColor || 'rgba(107, 114, 128, 0.1)'
  }

  const getDynamicStatusText = (statusName?: string, fallbackDisplayName?: string) => {
    if (!statusName) return '-'
    const status = approvalStatuses.value.find((s: any) => s.Name === statusName)
    return status?.Description || fallbackDisplayName || statusName
  }

  return {
    approvalStatuses,
    fetchApprovalStatuses,
    getDynamicStatusColor,
    getDynamicStatusBg,
    getDynamicStatusText
  }
}
